import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import ErrorPopUp from "../ErrorPopUp";

import "./QuoteValidatePoConsistency.scss";

const QuoteValidatePoConsistency = (props) => {
  const { t, quoteId, setQuoteData, siteId, setQuoteItemDateError, quoteData } =
    props;

  const history = useNavigate();
  const [isYesClicked, setYesClickStatus] = useState(false);
  const [showErrorPopup, setErrorPopupvisibility] = useState(false);
  const [apiError, setApiError] = useState("");

  const DatesExsit = () => {
    let dateError = false;
    quoteData?.services.map((service) => {
      if (service?.items && service?.items.length > 0) {
        service?.items.map((item) => {
          if (item.startDate === "" || item.endDate === "") {
            dateError = true;
          }
        });
      }
    });
    if (dateError) {
      setQuoteItemDateError("KICK_OFF_PAGE_QUOTE_ITEM_MISSING_DATES_ERROR");
    }
    if (!dateError) {
      setQuoteItemDateError("");
    }
    return dateError;
  };

  const handleYesClick = () => {
    const dateError = DatesExsit();
    if (!dateError) {
      setYesClickStatus(true);
      setErrorPopupvisibility(false);
      setApiError("");

      const dataModified = new FormData();
      dataModified.append("newStatusId", 1);
      dataModified.append("quoteId", quoteId);
      dataModified.append("siteId", siteId);

      axios
        // .get(`/quotes/${quoteId}/updateKoStatus`, {})
        .post(`/quotes/${quoteId}/updateKoStatus`, dataModified, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (response) {
          if (window.__DEV__) {
            console.info("KO: PO Consistency", response);
          }
          setQuoteData(response.data[0]);
          // props.showLoader(false);
          setYesClickStatus(false);
          setErrorPopupvisibility(false);
          setApiError("");
          // props.updateQuoteProductsSyncStatus(response.data);
        })
        .catch((err) => {
          if (window.__DEV__) {
            console.error("KO: PO Consistency", err.response);
          }
          if (err.response.status === 401) {
            window.location.href = `${window.location.origin}/login?redirect=ko`;
          }
          setErrorPopupvisibility(true);
          setApiError(t(err.response.data.message));
          // props.showLoader(false);
          setYesClickStatus(false);
        });
    }
  };

  const handleNoClick = () => {
    setErrorPopupvisibility(false);
    setApiError("");

    $.confirm({
      title: "",
      content: t("KICK_OFF_PAGE_QUOTE_SUMMARY_PO_CONSISTENCY_ALERT_CANCEL"),
      buttons: {
        no: {
          text: t(
            "KICK_OFF_PAGE_QUOTE_SUMMARY_PO_CONSISTENCY_ALERT_BUTTON_CANCEL"
          ),
        },
        yes: {
          text: t(
            "KICK_OFF_PAGE_QUOTE_SUMMARY_PO_CONSISTENCY_ALERT_BUTTON_YES"
          ),
          action() {
            // props.showLoader(true);
            const dataModified = new FormData();
            dataModified.append("newStatusId", 5);
            dataModified.append("quoteId", quoteId);
            axios
              .post(`/quotes/${quoteId}/transitionStatus`, dataModified, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then(function (response) {
                if (window.__DEV__) {
                  console.info("KO: PO Consistency Cancelled", response);
                }
                setQuoteData(response.data[0]);
                // props.showLoader(false);
                setErrorPopupvisibility(false);
                setApiError("");
                if (response.data.redirectUrl !== "") {
                  history(`/site/view/${siteId}/general-info`);
                }
                // props.removeQuote(quoteId);
              })
              .catch((err) => {
                if (window.__DEV__) {
                  console.error("KO: PO Consistency Cancel", err.response);
                }
                if (err.response.status === 401) {
                  window.location.href = `${window.location.origin}/login?redirect=ko`;
                }
                // props.showLoader(false);
                setErrorPopupvisibility(true);
                setApiError(t(err.response.data.message));
              });
          },
        },
      },
    });
  };

  const closePopup = () => {
    setErrorPopupvisibility(false);
    setApiError("");
  };

  return (
    <>
      {showErrorPopup && (
        <ErrorPopUp
          title={t("KICK_OFF_ERROR_BOX_TITLE")}
          btnText={t("KICK_OFF_ERROR_BOX_OK")}
          message={apiError}
          onOkClick={closePopup}
        />
      )}

      <div className="kick-off-po-consistency__container">
        <div className="kick-off-po-consistency__wrapper">
          <p className="kick-off-po-consistency__question">
            {t("KICK_OFF_PAGE_QUOTE_SUMMARY_PO_CONSISTENCY_QUESTION")}
          </p>
          <div className="kick-off-po-consistency__btn-wrapper">
            <button
              className="kick-off-po-consistency__btn-yes"
              onClick={() => {
                if (!isYesClicked) {
                  handleYesClick();
                }
              }}
            >
              {t("VALIDATE")}
            </button>
            <button
              className="kick-off-po-consistency__btn-no"
              onClick={handleNoClick}
            >
              {t("KICK_OFF_PAGE_QUOTE_SUMMARY_PO_CONSISTENCY_BUTTON_NO")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default withTranslation()(QuoteValidatePoConsistency);
